import { Box, Avatar, } from '@mui/material';
import me from '../me.png';
import { useTheme } from '@mui/system';

export default function ProfileHeader() {
  const theme = useTheme();
  return (
    <div className="stars">
      <div className="twinkling">
        <div style={{ height: 400, width: '100%', justifyContent: 'center', alignItems: 'flex-end', display: 'flex', }}>
          <Box sx={{ position: 'absolute', top: { xs: 240, lg: 270 } }}>
            <div style={{ display: 'flex', justifyContent: 'center', }} >
              <div style={{ backgroundColor: theme.palette.background.paper, borderRadius: '50%', padding: 4, }}>
                <Avatar src={me} alt="Bryan Maldonado" sx={{ width: 200, height: 200, }} />
              </div>
            </div>
          </Box>
        </div>

      </div>
    </div>
  );
}